export default "__VITE_ASSET__c82599aa__"